import { useState } from 'react';
import { AnchoredMenu } from '@rossum/components/anchored-menu/AnchoredMenu';
import { Popover } from '@rossum/ui/material';
import { RoleRestrictor } from '../../../components/Restrictors';
import {
  AnnotationsLabelsList,
  OnLabelAction,
} from '../../labels/AnnotationsLabelsList';
import {
  MENU_MAX_HEIGHT,
  MENU_MIN_HEIGHT,
  MENU_WIDTH,
} from '../../labels/components/constants';

type Props<T extends { labels: Array<string>; url: string }> = {
  onLabel: OnLabelAction;
  selectedAnnotations: Array<T>;
  children: ({ isOpen }: { isOpen: boolean }) => React.ReactNode;
  nested?: boolean;
  onParentClose?: () => void;
};

const BatchLabels = <T extends { labels: Array<string>; url: string }>({
  children,
  selectedAnnotations,
  onLabel,
  nested,
  onParentClose,
}: Props<T>) => {
  const [isExiting, setIsExiting] = useState<boolean>(false);

  return (
    <RoleRestrictor
      requiredRoles={[
        'admin',
        'organization_group_admin',
        'manager',
        'empowered_manager',
        'annotator',
      ]}
    >
      <AnchoredMenu
        nested={nested}
        renderContent={({
          anchorEl,
          open,
          onClose,
          anchorOrigin,
          transformOrigin,
        }) => (
          <Popover
            open={open}
            onClose={onClose}
            anchorEl={anchorEl}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            PaperProps={{
              sx: {
                maxHeight: MENU_MAX_HEIGHT,
                minHeight: MENU_MIN_HEIGHT,
                width: MENU_WIDTH,
              },
            }}
            TransitionProps={{
              onExited: () => {
                if (isExiting) setIsExiting(false);
              },
            }}
          >
            <AnnotationsLabelsList
              annotations={selectedAnnotations}
              onLabelsChanged={onLabel}
              onClose={() => {
                onClose();
                onParentClose?.();
                setIsExiting(true);
              }}
              isClosing={isExiting}
            />
          </Popover>
        )}
      >
        {children}
      </AnchoredMenu>
    </RoleRestrictor>
  );
};

export { BatchLabels };
